export const defaultEditorContent = {
  type: "doc",
  content: [
    {
      type: "paragraph",
      content: [],   
    }
  ],
};
